<div class="container">
  @if (translationsReady$ | async) {
    <app-header></app-header>
    <router-outlet></router-outlet>
  } @else {
    <nimbus-spinner [small]="false" [height]="120"></nimbus-spinner>
  }
</div>
